// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
  Tooltip,
  Button,
  // Divider,
  // ListItem,
  // ListItemText,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import axios from "axios.js";
import DataTable from "theme/Tables/DataTable";
import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";

function LicensePurchasePage() {
  const pageTitle = "License Purchase";
  usePageTitle(pageTitle);

  const { ref } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [refreshPage, setRefreshPage] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);

  const [purchase, setPurchase] = useState(null);
  const [agents, setAgents] = useState([]);
  const [availableLicenses, setAvailableLicenses] = useState(0);

  const [subscriptionPaymentDuration, setSubscriptionPaymentDuration] = useState(null);
  // const [pagBundleQty, setPagBundleQty] = useState(1);
  const [openRenewDialog, setOpenRenewDialog] = useState(false);

  const [agentGroups, setAgentGroups] = useState([]);
  const [selectedAgentGroup, setSelectedAgentGroup] = useState([]);
  const [openAssignDialog, setOpenAssignDialog] = useState(false);

  const [staffNumber, setStaffNumber] = useState(null);
  const [openAssignAgentDialog, setOpenAssignAgentDialog] = useState(false);

  async function revokeLicense(agentRef) {
    setShowLoading(true);
    await axios
      .get(`portal/account/licenses/${agentRef}/revoke.json`)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  const tableAgentsColumns = [
    { Header: "Agent", accessor: "agent", align: "left" },
    { Header: "Assigned On", accessor: "created", align: "left" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildAgentsRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        agent: row.agent,
        created: row.created,
        actions: (
          <MDBox mt={1} variant="button">
            {row.status && (
              <MDButton
                size="small"
                variant="outlined"
                color="error"
                iconOnly
                onClick={() => {
                  if (window.confirm("Revoke License?") === true) {
                    revokeLicense(row.reference);
                  }
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="error">
                  close
                </Icon>
              </MDButton>
            )}
          </MDBox>
        ),
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`portal/account/licenses/${ref}/fetch.json`)
        .then((result) => {
          console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setPurchase(result.data.data.purchase);
            setAvailableLicenses(result.data.data.available);
            setAgentGroups(result.data.data.agent_groups);
            const rows = buildAgentsRows(result.data.data.agents);
            setAgents(rows);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function renew() {
    // if (pagBundleQty == null || pagBundleQty < 1) {
    //   setSeverity("error");
    //   setErrMsg("Please enter a bundle quantity.");
    //   setOpen(true);
    //   return;
    // }

    if (subscriptionPaymentDuration == null || subscriptionPaymentDuration <= 0) {
      setSeverity("error");
      setErrMsg("Please select a duration");
      setOpen(true);
      return;
    }

    if (window.confirm(`Proceed with payment?`) === false) {
      return;
    }

    setOpenRenewDialog(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      // bundle_quantity: pagBundleQty,
      duration: subscriptionPaymentDuration,
    };

    await axios
      .post("portal/account/licenses/renew.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function assign() {
    if (selectedAgentGroup == null) {
      setSeverity("error");
      setErrMsg("Please select an agent group.");
      setOpen(true);
      return;
    }

    if (window.confirm(`Proceed?`) === false) {
      return;
    }

    setOpenAssignDialog(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      agent_group: selectedAgentGroup,
    };

    await axios
      .post("portal/account/licenses/assign.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function assignAgent() {
    if (staffNumber == null) {
      setSeverity("error");
      setErrMsg("Please your agent's staff number");
      setOpen(true);
      return;
    }

    if (window.confirm(`Proceed?`) === false) {
      return;
    }

    setOpenAssignAgentDialog(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      agent: staffNumber,
    };

    await axios
      .post("portal/account/licenses/assign/agent.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openRenewDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Renew License</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={0} mb={3}>
            <MDBox p={1.5}>
              {/* <MDBox mt={1}>
                <MDInput
                  placeholder="1"
                  name="qty"
                  margin="dense"
                  label="Bundle Quantity"
                  type="number"
                  fullWidth
                  variant="outlined"
                  value={pagBundleQty}
                  onChange={(e) => setPagBundleQty(e.target.value)}
                />
              </MDBox> */}
              <MDBox mt={0} mb={0}>
                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                  <InputLabel>Duration</InputLabel>
                  <Select
                    label="Duration"
                    onChange={(e) => {
                      setSubscriptionPaymentDuration(e.target.value);
                    }}
                    sx={{ padding: "12px", paddingLeft: "3px" }}
                  >
                    <MenuItem value="1">1 Month</MenuItem>
                    <MenuItem value="2">2 Months</MenuItem>
                    <MenuItem value="3">3 Months</MenuItem>
                    <MenuItem value="6">6 Months</MenuItem>
                    <MenuItem value="12">12 Months</MenuItem>
                  </Select>
                </FormControl>
              </MDBox>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenRenewDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="success"
            variant="contained"
            onClick={() => {
              renew();
            }}
          >
            Renew
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openAssignDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Assign To Agent Group</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={0}>
            <MDBox p={1}>
              <MDBox mt={1}>
                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                  <InputLabel>Select Agent Group</InputLabel>
                  <Select
                    label="Select Agent Group"
                    onChange={(e) => {
                      setSelectedAgentGroup(e.target.value);
                    }}
                    sx={{ padding: "12px", paddingLeft: "3px" }}
                  >
                    {agentGroups.map((group) => (
                      <MenuItem value={group.reference}>{group.title}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </MDBox>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenAssignDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              assign();
            }}
          >
            Assign
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openAssignAgentDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Assign To Agent</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={0}>
            <MDBox p={1}>
              <MDBox mt={1}>
                <MDInput
                  name="staff_number"
                  margin="dense"
                  label="Agent Staff Number"
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={staffNumber}
                  onChange={(e) => setStaffNumber(e.target.value)}
                />
              </MDBox>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenAssignAgentDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              assignAgent();
            }}
          >
            Assign
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox pt={3} pb={3}>
        {pageLoaded && (
          <MDBox>
            <MDBox>
              <Button
                color="dark"
                startIcon={<Icon>west</Icon>}
                onClick={() => {
                  if (window.history.length > 1) {
                    window.history.back();
                  } else {
                    navigate(`/licenses`);
                  }
                }}
              >
                Back
              </Button>
            </MDBox>
            <MDBox mt={1}>
              <Grid container spacing={3}>
                <Grid item xs={8} md={8} lg={8}>
                  <MDBox sx={{ height: "100%" }}>
                    <Card sx={{ height: "100%" }}>
                      <MDBox p={3}>
                        <MDBox mb={3}>
                          <MDTypography variant="h6">{purchase.title}</MDTypography>
                        </MDBox>
                        <MDBox mt={6}>
                          <MDBox display="flex" justifyContent="space-between">
                            <MDBox align="left">
                              <MDTypography variant="subtitle2">
                                Purchased On
                                <br />
                                <b>{purchase.created}</b>
                              </MDTypography>
                            </MDBox>
                            <MDBox align="right">
                              <MDTypography variant="subtitle2">
                                Expires On
                                <br />
                                <b>{purchase.expires_on}</b>
                              </MDTypography>
                            </MDBox>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </Card>
                  </MDBox>
                </Grid>
                <Grid item xs={4} md={4} lg={4}>
                  <MDBox sx={{ height: "100%" }}>
                    <Card sx={{ height: "100%" }}>
                      <MDBox p={3} align="center">
                        <MDBox>
                          <MDBox sx={{ position: "relative", display: "inline-flex" }}>
                            <CircularProgress
                              variant="determinate"
                              size={100}
                              thickness={3}
                              value={100}
                              color={availableLicenses <= 0 ? "error" : "info"}
                            />
                            <MDBox
                              sx={{
                                top: 0,
                                left: 0,
                                bottom: 0,
                                right: 0,
                                position: "absolute",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <MDTypography
                                variant="caption"
                                component="div"
                                color={availableLicenses <= 0 ? "error" : "info"}
                                fontSize={20}
                              >
                                <b>{availableLicenses}</b>
                              </MDTypography>
                            </MDBox>
                          </MDBox>
                        </MDBox>
                        <MDTypography variant="h6">Available Licenses</MDTypography>
                      </MDBox>
                    </Card>
                  </MDBox>
                </Grid>
              </Grid>
            </MDBox>
            <MDBox mt={5}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox p={2}>
                  <MDBox
                    pt={2}
                    px={2}
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <MDTypography variant="h6" fontWeight="medium">
                      Assigned Agents
                    </MDTypography>
                    <MDBox display="flex" justifyContent="space-evenly">
                      <Tooltip title="Assign Agent">
                        <MDButton
                          variant="contained"
                          color="dark"
                          onClick={() => {
                            if (!purchase.status) {
                              return;
                            }
                            setStaffNumber(null);
                            setOpenAssignAgentDialog(true);
                          }}
                          iconOnly
                        >
                          <Icon sx={{ fontWeight: "bold" }}>person_add_alt</Icon>
                        </MDButton>
                      </Tooltip>
                      &nbsp;
                      <Tooltip title="Assign Group">
                        <MDButton
                          variant="contained"
                          color="dark"
                          onClick={() => {
                            if (!purchase.status) {
                              return;
                            }
                            setOpenAssignDialog(true);
                          }}
                          iconOnly
                        >
                          <Icon sx={{ fontWeight: "bold" }}>group_add</Icon>
                        </MDButton>
                      </Tooltip>
                      &nbsp; &nbsp;
                      <Tooltip title="Extend License">
                        <MDButton
                          variant="contained"
                          color="success"
                          onClick={() => {
                            setOpenRenewDialog(true);
                          }}
                          iconOnly
                        >
                          <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                        </MDButton>
                      </Tooltip>
                      {/* {!purchase.status ? (
                        <>
                          &nbsp;&nbsp;
                          <MDButton
                            variant="contained"
                            color="success"
                            size="small"
                            onClick={() => {
                              setOpenRenewDialog(true);
                            }}
                            startIcon={<Icon sx={{ fontWeight: "bold" }}>repeat</Icon>}
                          >
                            Renew
                          </MDButton>
                        </>
                      ) : (
                        <> </>
                      )} */}
                    </MDBox>
                  </MDBox>
                  <MDBox mt={5}>
                    <DataTable
                      table={{ columns: tableAgentsColumns, rows: agents }}
                      isSorted
                      entriesPerPage={false}
                      showTotalEntries
                      noEndBorder
                    />
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default LicensePurchasePage;
